var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.isStaging)?_c('div',[_c('h3',{attrs:{"id":"staging-banner"}},[_vm._v("***You are currently accessing the STAGING site***")])]):_vm._e(),_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }